import FiveCricketGame from "../superOver/FiveCricketGame";

export default function SuperOver2() {
  return <FiveCricketGame defaultName="superOver2" />;
}
